import EmployeeOrdersView from 'components/organisms/employee-orders/EmployeeOrdersView'
import React from 'react'

const Orders = () => {
    return (
        <EmployeeOrdersView />
    )
}

export default Orders